import { useHistory } from '@framework/ui/core/router/TypedRoute.tsx';
import { useMemo } from 'react';
import { SubmissionMenuKey } from '../hooks/SubmissionMenuKey.ts';

/**
 * Hook che, partendo dalla location corrente, restituisce la chiave del menu
 * selezionata attualmente.
 * /invia -> Report
 * /report -> Report
 * /pagamenti -> Payment
 * /moduli/:moduleId -> moduleId
 * / -> Guide
 */
export function useSubmissionMenuSelectedKey() {
  const history = useHistory();

  const menuSelectedKey = useMemo(() => {
    const pathname = history.location.pathname as string;
    if (pathname.endsWith('invia')) {
      return SubmissionMenuKey.Report;
    }
    if (pathname.endsWith('pagamenti') || pathname.endsWith('payments')) {
      return SubmissionMenuKey.Payment;
    }
    // Rotta riepilogo `/report`: Backoffice e Frontoffice nella vista inviata
    // (in compilazione il Frontoffice usa invece `/invia`, gestito sopra).
    if (pathname.endsWith('report')) {
      return SubmissionMenuKey.Report;
    }
    if (!pathname.includes('moduli') && !pathname.includes('modules')) {
      return SubmissionMenuKey.Guide;
    }
    // /moduli/:moduleId
    const moduleId = pathname.split('/').pop();

    return moduleId;
  }, [history.location.pathname]);

  return menuSelectedKey;
}

export function isModuleSelected(menuSelectedKey: string | null | undefined) {
  if (!menuSelectedKey) return false;
  return ![
    SubmissionMenuKey.Guide,
    SubmissionMenuKey.Payment,
    SubmissionMenuKey.Report,
  ].includes(menuSelectedKey as any);
}
